
import { FileDownloadOutlined, KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';
import { Box, Button, Card, CardHeader, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Table, TableBody, TableCell, TableHead, TableRow, Tooltip } from '@mui/material';
import { generateClient } from 'aws-amplify/api';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../contexts/UserContext';
import { esQuery } from '../../graphql/queries';
import { actionTwoButtonStyle, cardStyle } from '../../theme';


const CampaignCallSuppressDialog = ({ open, data, totalSuppressionCount, campaignId, inputStartDate, inputEndDate }) => {
	const client = generateClient();
	const [loading, setLoading] = useState(false);
	const userContext = useContext(UserContext);

	const [suppressionData, setSuppressionData] = useState([]);

	useEffect(() => {
		if (open) {
			setLoading(true);
			setLoading(false);
			const suppressions = [];
			let suppressionCount = 0;

			const activitylogSupppressions = {
				label: 'Activity Log Suppressions',
				value: 0,
				dispositions: []
			}

			const pointOfContactSupppressions = {
				label: 'Point of Contact Suppressions',
				value: 0,
				dispositions: []
			}

			const restCallSupppressions = {
				label: 'REST Call Suppressions',
				value: 0,
				dispositions: []
			}

			const dncListSupppressions = {
				label: 'DNC List Suppressions',
				value: 0,
				dispositions: []
			}

			const contactFieldSuppression = {
				label: 'Contact Field Suppressions',
				value: 0,
				dispositions: []
			}

			const dncDotComSuppression = {
				label: 'DNC.com Suppressions',
				value: 0,
				dispositions: []
			}

			const externalSuppression = {
				label: 'External Suppression (Contact Removed from Segment)',
				value: 0,
				dispositions: []
			}

			const agentSuppressions = {
				label: 'Agent Suppressions',
				value: 0
			}

			for (const suppression of data) {
				if (suppression.key.includes('activity log')) {
					activitylogSupppressions.value = activitylogSupppressions.value + suppression.doc_count;
					activitylogSupppressions.dispositions = [...activitylogSupppressions.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
				if (suppression.key.includes('point of contact')) {
					pointOfContactSupppressions.value = pointOfContactSupppressions.value + suppression.doc_count;
					pointOfContactSupppressions.dispositions = [...pointOfContactSupppressions.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
				if (suppression.key.includes('REST') || suppression.key.includes('response key')) {
					restCallSupppressions.value = restCallSupppressions.value + suppression.doc_count;
					restCallSupppressions.dispositions = [...restCallSupppressions.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
				if (suppression.key.includes('DNC') && !suppression.key.includes('DNC.com')) {
					dncListSupppressions.value = dncListSupppressions.value + suppression.doc_count;
					dncListSupppressions.dispositions = [...dncListSupppressions.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
				if (suppression.key.includes('contact field')) {
					contactFieldSuppression.value = contactFieldSuppression.value + suppression.doc_count;
					contactFieldSuppression.dispositions = [...contactFieldSuppression.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
				if (suppression.key.includes('DNC.com')) {
					dncDotComSuppression.value = dncDotComSuppression.value + suppression.doc_count;
					dncDotComSuppression.dispositions = [...dncDotComSuppression.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
				if (suppression.key.includes('no longer')) {
					externalSuppression.value = externalSuppression.value + suppression.doc_count;
					externalSuppression.dispositions = [...externalSuppression.dispositions, { key: suppression.key, count: suppression.doc_count }]
					suppressionCount = suppressionCount + suppression.doc_count;
				}
			}

			const missingSuppressions = totalSuppressionCount - suppressionCount;
			if (missingSuppressions > 0) {
				agentSuppressions.value = missingSuppressions;
				agentSuppressions.dispositions = [{ key: 'Other Suppressions', count: missingSuppressions }]
				suppressions.push(agentSuppressions);
			}

			if (activitylogSupppressions.value > 0) {
				suppressions.push(activitylogSupppressions);
			}
			if (pointOfContactSupppressions.value > 0) {
				suppressions.push(pointOfContactSupppressions);
			}
			if (restCallSupppressions.value > 0) {
				suppressions.push(restCallSupppressions);
			}
			if (dncListSupppressions.value > 0) {
				suppressions.push(dncListSupppressions);
			}
			if (contactFieldSuppression.value > 0) {
				suppressions.push(contactFieldSuppression);
			}
			if (dncDotComSuppression.value > 0) {
				suppressions.push(dncDotComSuppression);
			}
			if (externalSuppression.value > 0) {
				suppressions.push(externalSuppression);
			}


			setSuppressionData(suppressions);
			setLoading(false);
		}
	}, [open]);

	const downloadCSV = async (suppression) => {
		let baseQuery = {
			"query": {
				"bool": {
					"must": [
						{
							"term": {
								"tenant.keyword": userContext.tenantId
							}
						},
						{
							"term": {
								"type.keyword": "DialSuppress"
							}
						},
						{
							"term": {
								"activityLogCampaignId.keyword": campaignId
							}
						},
						{
							"range": {
								"timestamp": {
									"gte": inputStartDate ? inputStartDate : moment().startOf('day').toISOString(),
									"lte": inputEndDate ? inputEndDate : moment().toISOString()
								}
							}
						}
					],
					"must_not": [
						{
							"term": {
								"metaData.dispDescription.keyword": "The contact was outside the specified curfew bounds and will be retried."
							}
						},
						{
							"term": {
								"metaData.dispDescription.keyword": "The contact was outside the specified call window bounds for the point of contact."
							}
						}
					]
				}
			},
			"_source": [
				"disposition",
				"agent",
				"activityLogContactId",
				"metaData.contactExternalId",
				"activityLogSegmentId",
				"timestamp",
				"metaData.dispDescription"
			],
			"sort": [{ "timestamp": "asc" }, { "_id": "asc" }],
			"size": 10000
		};

		// Paginate through all results using search_after
		let allResults = [];
		let searchAfter = null;

		while (true) {
			const query = { ...baseQuery };
			if (searchAfter) {
				query.search_after = searchAfter;
			}

			const results = await client.graphql({
				query: esQuery,
				variables: {
					model: 'activitylog-*',
					action: '_search',
					query: JSON.stringify(query)
				}
			});

			const hits = JSON.parse(results.data.esQuery).hits.hits;
			if (!hits || hits.length === 0) break;

			allResults = allResults.concat(hits);
			searchAfter = hits[hits.length - 1].sort;

			if (hits.length < 10000) break;
		}

		let csvData = `${userContext.telephonyProvider !== 'Webex' ? 'External Id,' : ''}Velocity Id,Disposition,Agent,Segment,Timestamp,Description\n`;
		allResults.forEach((result) => {
			const { metaData, disposition, agent, activityLogContactId, activityLogSegmentId, timestamp } = result._source;
			switch (suppression) {
				case 'Activity Log Suppressions':
					if (metaData?.dispDescription?.includes('activity log')) {
						csvData += `"${userContext.telephonyProvider !== 'Webex' ? metaData?.contactExternalId + '","' : ''}${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					}
					break;
				case 'Point of Contact Suppressions':
					if (metaData?.dispDescription?.includes('point of contact')) {
						csvData += `"${userContext.telephonyProvider !== 'Webex' ? metaData?.contactExternalId + '","' : ''}${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					}
					break;
				case 'REST Call Suppressions':
					if (metaData?.dispDescription?.includes('REST') || metaData?.dispDescription?.includes('response key')) {
						csvData += `"${userContext.telephonyProvider !== 'Webex' ? metaData?.contactExternalId + '","' : ''}${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					}
					break;
				case 'DNC List Suppressions':
					if (metaData?.dispDescription?.includes('DNC') && !metaData?.dispDescription?.includes('DNC.com')) {
						csvData += `"${metaData?.contactExternalId}", "${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					}
					break;
				case 'Contact Field Suppressions':
					if (metaData?.dispDescription?.includes('contact field')) {
						csvData += `"${metaData?.contactExternalId}", "${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					}
					break;
				case 'DNC.com Suppressions':
					if (metaData?.dispDescription?.includes('DNC.com')) {
						csvData += `"${metaData?.contactExternalId}", "${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					}
					break;
				case 'External Suppression (Contact Removed from Segment)':
					if (metaData?.dispDescription?.includes('no longer'))
						csvData += `"${userContext.telephonyProvider !== 'Webex' ? metaData?.contactExternalId + '","' : ''}${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
					break;
				case 'Agent Suppressions':
					if (metaData?.dispDescription?.includes("Approver")) {
						csvData += `"${userContext.telephonyProvider !== 'Webex' ? metaData?.contactExternalId + '","' : ''}${activityLogContactId}","${disposition}","${agent}","${activityLogSegmentId}","${timestamp}","${metaData?.dispDescription}"\n`;
						break;
					}

			}
		});

		const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
		const url = URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', `${suppression.replace(/\s+/g, '_')}_Suppression.csv`);
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		URL.revokeObjectURL(url);
		// Clean up the blob URL after use
		URL.revokeObjectURL(url);
	}

	function GetRow(props) {
		const [open, setOpen] = useState(false);
		const { suppression } = props;

		return (
			<>
				<TableRow key={suppression.label} sx={{ cursor: 'pointer' }}>
					{suppression?.dispositions && <TableCell onClick={() => setOpen(!open)}>{open ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}</TableCell>}
					<TableCell onClick={() => setOpen(!open)}>{suppression.label} </TableCell>
					<TableCell onClick={() => setOpen(!open)}>{suppression.value}</TableCell>
					<TableCell align="right">
						<Tooltip title="Download CSV" placement="top">
							<IconButton onClick={() => {
								downloadCSV(suppression.label);
							}
							}>
								<FileDownloadOutlined color="primary" />
							</IconButton>
						</Tooltip>
					</TableCell>
				</TableRow>
				<TableRow key={suppression.label + 'details'} sx={{ display: open ? 'table-row' : 'none' }}>
					<TableCell colSpan={4}>
						<Table sx={{ width: '100%' }}>
							<TableHead>
								<TableRow>
									<TableCell>Details</TableCell>
									<TableCell>Count</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{suppression?.dispositions?.map((disposition) => (
									<TableRow key={disposition.key}>
										<TableCell>{disposition.key}</TableCell>
										<TableCell>{disposition.count}</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableCell>
				</TableRow>
			</>
		);
	}


	return (
		<Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
			{!loading && <Box sx={{ width: '100%' }} display="grid" gridTemplateColumns="1fr">
				<Card variant="outlined" sx={cardStyle}>
					<CardHeader title="Suppressions" />
					<Table sx={{ width: '100%' }}>
						<TableHead>
							<TableRow>
								<TableCell />
								<TableCell>Suppression</TableCell>
								<TableCell>Count</TableCell>
								<TableCell align="right" />
							</TableRow>
						</TableHead>
						<TableBody>
							{suppressionData.map((suppression) => <GetRow suppression={suppression} />)}
						</TableBody>
					</Table>
				</Card>
			</Box>}
			{loading ? <CircularProgress /> : null}
		</Box>
	);
};

export default CampaignCallSuppressDialog;